import BaseViewController from "../base-view-controller";
import { removeCachedKeys } from "../../utils/app-data-utils";
import { APP_DATA_VALUE_KEYS } from "../../utils/constants";

class BiometricsViewController extends BaseViewController {
  preprocessScreenData() {
    const { fields } = this.screen;

    const usernamePasswordContainer = fields.find(f =>
      f.name.includes("username_password_container")
    );
    const securityQuestionsContainer = fields.find(f =>
      f.name.includes("security_questions_container")
    );
    const signInContainerFields =
      usernamePasswordContainer?.fieldLayouts[0]?.containerFields;
    const securityQuestionsContainerFields =
      securityQuestionsContainer?.fieldLayouts[0]?.containerFields;
    const signInTitle = fields.find(f => f.name.includes("sign_in_section"));
    const securityQuestionsTitle = fields.find(f =>
      f.name.includes("security_question_section_title")
    );

    const createSections = () => {
      if (!usernamePasswordContainer.name.includes("section-web-sdk")) {
        usernamePasswordContainer.name += " section-web-sdk";
        securityQuestionsContainer.name += " section-web-sdk";
      }
    };

    const insertTitlesToSections = () => {
      if (signInContainerFields[0]?.name === "username_container")
        signInContainerFields.unshift(signInTitle);

      if (
        securityQuestionsContainerFields[0]?.name ===
        "security_questions_container_0"
      ) {
        securityQuestionsTitle.fieldLayouts[0].containerFields.forEach(f =>
          securityQuestionsContainerFields.unshift(f)
        );
      }
    };

    createSections();
    insertTitlesToSections();
    super.preprocessScreenData();

    // Temporary solution to avoid form fields on Securty Answers to be auto-populated after saveing.
    const allowedValueKeys = [APP_DATA_VALUE_KEYS.loggedInMemberId];

    removeCachedKeys(this.appData.values, allowedValueKeys);
  }
}

export default BiometricsViewController;
